// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
Vue.prototype.$axios = axios;
const baseURL = ""
if (process.env.NODE_ENV =='development') {
  axios.defaults.baseURL = '/pest'
}else{
  axios.defaults.baseURL = '/pest'
}

console.log(axios.defaults.baseURL)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js